import { SET_RIGHT_SIDEBAR, SET_LEFT_SIDEBAR } from './mutation_types'
const user = {
  state: {
    bars: {
      left: false,
      right: false
    },
  },

  mutations: {
    SET_LEFT_SIDEBAR: (state, payload) => {
      state.bars.left = payload;
    },
    SET_RIGHT_SIDEBAR: (state, payload) => {
      state.bars.right = payload;
    },
  },

  actions: {
    setLeftSidebar ({ commit, state }) {
      commit(SET_LEFT_SIDEBAR, !state.bars.left);
    },
    setRightSidebar ({ commit, state }) {
      commit(SET_RIGHT_SIDEBAR, !state.bars.right);
    },
  }
};

export default user;
